import type { SVGProps } from 'react';
const SvgContact = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M14.774 3.534 9.344 7.71a2.205 2.205 0 0 1-2.689 0L1.226 3.534M2 3.167h12s1 0 1 1v8s0 1-1 1H2s-1 0-1-1v-8s0-1 1-1"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgContact;
